import React, { useState, useEffect, useMemo, useRef } from "react";
import { useAppSelector } from "hooks/redux";
import Tables from "components/TableViewMods";
import { MockTitle, SectionTab, TitleInput, Wrapper } from "./quotesPageStyles";
import { showModal } from "store/reducers/modal";
import { useDispatch } from "react-redux";
import { useDragContext } from "components/drag";
import tablesSortWrapper from "../../utils/sortWorkspaces";

import { setSelectedTickers, setUploadedFile } from "store/reducers/quotes";
import { updateTab, updateWorkspace } from "store/reducers/QuotesPageReducer";
import {
    renameTab,
    toggleSectionStatus,
    updateAreaPickedTickers,
} from "../../store/reducers/TabsSlice";
import { Button, Spin } from "antd";
import Error from "utils/Notifications/Error";
import {
    enableInactivityGuard,
    disableInactivityGuard,
} from "managers/inactivityManager";

const QuotesPage = () => {
    const { selectedRobotId } = useAppSelector((state) => state.robots);

    useEffect(() => {
        enableInactivityGuard();

        return () => {
            disableInactivityGuard();
        };
    }, []);

    const dispatch = useDispatch();
    const activePage = useAppSelector((state) => state.quotesPage.activePage);

    const { workspaces, currentTab } = useAppSelector((state) => state.tabs);
    // console.log('currentTab',currentTab);

    const available_tickers = useAppSelector(
        (state) => state.quotes.available_tickers_persistent,
    );
    const { grid, order } = useAppSelector((state) => state.quotes);

    const [isClosedByEsc, setIsClosedByEsc] = useState(false);

    const {
        state: { items },
    } = useDragContext();

    const [state, setState] = useState<{
        workspaces: any[];
        currentTab: any;
        name: string;
        _initial_workspace_fetch_done: boolean;
    }>({
        workspaces: [],
        currentTab: {},
        name: activePage?.name || "",
        _initial_workspace_fetch_done: false,
    });

    const inputTitleRef = useRef(null);

    const handleTabTitleBlur = () => {
        if (isClosedByEsc) {
            setIsClosedByEsc(false);
            setState((prev) => ({
                ...prev,
                name: activePage.name,
            }));
            unfocusInput();
            return;
        }
        saveTitle(inputTitleRef.current.value);
    };

    const openAddTickers = (id: any) => {
        dispatch(
            showModal({
                modal_type: "ticker_picker",
                value: true,
                caller: id,
            }),
        );
    };
    const unfocusInput = () => {
        if (inputTitleRef.current) {
            inputTitleRef.current.blur();
        }
    };
    const saveTitle = (titleValue) => {
        const newName = titleValue.trim();
        const oldName = activePage?.name || "";
        if (newName === oldName) {
            unfocusInput();
            return;
        }

        console.log(newName, oldName);

        if (newName.length == 0) {
            Error("Название вкладки не может быть пустым!");

            setState({
                ...state,
                name: oldName,
            });

            return;
        }

        dispatch(
            renameTab({
                name: titleValue,
                id: activePage?.id,
            }),
        );
    };


    useEffect(() => {
        if (!selectedRobotId) {
            setState((prev) => ({
                ...prev,
                _initial_workspace_fetch_done: false,
                name: "",
            }));
            return;
        }
        if (activePage?.name !== state?.name) {
            setState((p) => ({
                ...p,
                name: activePage?.name,
                _initial_workspace_fetch_done: false,
            }));
        }
    }, [activePage?.id, selectedRobotId]);

    // function filterWorkspaceParams(workspaces: any[]) {
    //     return workspaces.slice().map((workspace) => ({
    //         ...workspace,
    //         params: workspace.params.filter((param) =>
    //             available_tickers.includes(param.Name)
    //         ),
    //     }));
    // }

    const filtered_workspaces = useMemo(() => {
        return tablesSortWrapper(
            workspaces.slice(),
            items.map((item) => parseInt(item.id)),
        );
    }, [workspaces, items]);

    const input_id = `title_input_${activePage?.id}`;

    const sectionsStatuses = useAppSelector(
        (store) => store.tabs.sectionStatuses,
    );

    return (
        <>
            <Wrapper>
                {!selectedRobotId && !activePage && <Spin />}
                {activePage?.name ? (
                    <div style={{ display: "flex" }}>
                        <TitleInput
                            id={input_id}
                            value={
                                (activePage ? state.name : "") ||
                                (!activePage ? "Выберите вкладку" : "")
                            }
                            onKeyDown={(
                                e: React.KeyboardEvent<HTMLInputElement>,
                            ) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    saveTitle(e.currentTarget.value);
                                    unfocusInput();
                                }
                                if (e.key === "Escape") {
                                    setIsClosedByEsc(true);
                                    setTimeout(() => {
                                        inputTitleRef.current?.blur();
                                    }, 1);
                                }
                            }}
                            onBlur={handleTabTitleBlur}
                            onChange={(e) => {
                                setState((prevState) => ({
                                    ...prevState,
                                    name: e.target.value.slice(0, 30),
                                }));
                            }}
                            ref={inputTitleRef}
                            // @ts-ignore
                            style={{ width: "50%" }}
                        />

                        <div
                            style={{
                                display: "flex",
                                gap: "5px",
                                alignItems: "center",
                            }}
                        >
                            {currentTab &&
                                currentTab.sections &&
                                selectedRobotId &&
                                Object.entries(sectionsStatuses).map(
                                    ([key, value]) =>
                                        value ? (
                                            <SectionTab key={key}>
                                                <div>
                                                    {currentTab.sections.find(
                                                        (section) =>
                                                            section.id ==
                                                            parseInt(key),
                                                    ).name &&
                                                    currentTab.sections.find(
                                                        (section) =>
                                                            section.id ==
                                                            parseInt(key),
                                                    ).name.length > 10
                                                        ? currentTab.sections
                                                              .find(
                                                                  (section) =>
                                                                      section.id ==
                                                                      parseInt(
                                                                          key,
                                                                      ),
                                                              )
                                                              .name.slice(
                                                                  0,
                                                                  10,
                                                              ) + "..."
                                                        : currentTab.sections.find(
                                                              (section) =>
                                                                  section.id ==
                                                                  parseInt(key),
                                                          ).name}
                                                </div>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                    }}
                                                >
                                                    <Button
                                                        size="small"
                                                        onClick={async () => {
                                                            dispatch(
                                                                updateWorkspace(
                                                                    {
                                                                        data: {
                                                                            is_collapsed:
                                                                                !value,
                                                                        },
                                                                        tabId: parseInt(
                                                                            key,
                                                                        ),
                                                                    },
                                                                ),
                                                            );
                                                            dispatch(
                                                                toggleSectionStatus(
                                                                    key,
                                                                ),
                                                            );
                                                        }}
                                                    >
                                                        {value ? "+" : "-"}
                                                    </Button>

                                                    <Button
                                                        size="small"
                                                        onClick={() => {
                                                            dispatch(
                                                                setUploadedFile(
                                                                    {
                                                                        caller: key,
                                                                        name: "",
                                                                        names: [],
                                                                    },
                                                                ),
                                                            );
                                                            dispatch(
                                                                setSelectedTickers(
                                                                    {
                                                                        id: key,
                                                                        data: [],
                                                                    },
                                                                ),
                                                            );
                                                            dispatch(
                                                                updateAreaPickedTickers(
                                                                    {
                                                                        workspace_id:
                                                                            activePage.id,
                                                                        area_id:
                                                                            key,
                                                                        picked_tickers:
                                                                            [].filter(
                                                                                (
                                                                                    x,
                                                                                ) =>
                                                                                    typeof x ===
                                                                                        "string" &&
                                                                                    x.length >
                                                                                        0,
                                                                            ),
                                                                    },
                                                                ),
                                                            );
                                                            dispatch(
                                                                toggleSectionStatus(
                                                                    key,
                                                                ),
                                                            );
                                                        }}
                                                    >
                                                        X
                                                    </Button>
                                                </div>
                                            </SectionTab>
                                        ) : (
                                            null
                                        ),
                                )}
                        </div>
                    </div>
                ) : (
                    <MockTitle>Выберите вкладку</MockTitle>
                )}
                {activePage &&
                activePage.id &&
                workspaces.length > 0 &&
                selectedRobotId ? (
                    <Tables
                        workspaces={filtered_workspaces}
                        activePage={activePage}
                        openAddTickers={openAddTickers}
                        currentTab={currentTab}
                        grid={grid}
                        order={order}
                    />
                ) : (
                    <p>Здесь пока ничего нет</p>
                )}
            </Wrapper>
        </>
    );
};

export default QuotesPage;
